export const generateNumber = (input: { min: number; max: number }): number =>
  Math.random() * (input.max - input.min) + input.min;
